const NaverAnalytics = {
  install(Vue) {
    if (process.env.VUE_APP_BUILD_NAME !== 'staging') return;

    Vue.createFile = () => {
      let lcslog = document.createElement('script');
      lcslog.setAttribute('type', 'text/javascript');
      lcslog.setAttribute('src', '/js/lcslog.js');
      document.head.appendChild(lcslog);

      let pageshowScript = document.createElement('script');
      pageshowScript.setAttribute('type', 'text/javascript');
      pageshowScript.innerHTML = `
        window.addEventListener('pageshow', function (event) {
          if(typeof lcs_do === 'function') {
            lcs_do();
          }
        });
      `;
      document.head.appendChild(pageshowScript);
    };

    Vue.addScript = () => {
      let scriptCode = document.createElement('script');
      scriptCode.setAttribute('type', 'text/javascript');
      scriptCode.innerHTML = `
        lcs_do();
      `;
      document.head.appendChild(scriptCode);
    };

    Vue.prototype.$addAnalytics = function() {
      Vue.createFile();
    };

    Vue.prototype.$reAddAnalytics = function() {
      Vue.addScript();
    };
  },
};

export default NaverAnalytics;
